module.exports = __webpack_public_path__ + "static/media/button-muenzen.937d4874.svg";